import { arabic as m } from "./arabic.js";
import { chineseSimplified as e } from "./chineseSimplified.js";
import { chineseTraditional as a } from "./chineseTraditional.js";
import { dutch as t } from "./dutch.js";
import { english as n } from "./english.js";
import { french as p } from "./french.js";
import { german as s } from "./german.js";
import { hebrew as f } from "./hebrew.js";
import { hindi as h } from "./hindi.js";
import { indonesian as c } from "./indonesian.js";
import { italian as d } from "./italian.js";
import { japanese as l } from "./japanese.js";
import { khmer as g } from "./khmer.js";
import { korean as u } from "./korean.js";
import { lao as k } from "./lao.js";
import { malay as b } from "./malay.js";
import { portuguese as w } from "./portuguese.js";
import { russian as j } from "./russian.js";
import { spanish as v } from "./spanish.js";
import { tagalog as y } from "./tagalog.js";
import { thai as C } from "./thai.js";
import { turkish as M } from "./turkish.js";
import { vietnamese as S } from "./vietnamese.js";
const o = {
  english: n,
  japanese: l,
  korean: u,
  chineseSimplified: e,
  chineseTraditional: a,
  german: s,
  spanish: v,
  french: p,
  italian: d,
  indonesian: c,
  malay: b,
  portuguese: w,
  russian: j,
  tagalog: y,
  thai: C,
  lao: k,
  vietnamese: S,
  arabic: m,
  hebrew: f,
  hindi: h,
  khmer: g,
  dutch: t,
  turkish: M
}, i = [
  o.english,
  o.japanese,
  o.korean,
  o.chineseSimplified,
  o.chineseTraditional,
  o.german,
  o.spanish,
  o.french,
  o.italian,
  o.indonesian,
  o.malay,
  o.portuguese,
  o.russian,
  o.tagalog,
  o.thai,
  o.lao,
  o.vietnamese,
  o.arabic,
  o.hebrew,
  o.hindi,
  o.khmer,
  o.dutch,
  o.turkish
], T = /* @__PURE__ */ new Map();
i.forEach((r) => {
  T.set(r.code, r);
});
const Y = i.map(
  (r) => r.code
);
export {
  T as localeCodeMap,
  o as locales,
  i as ordered,
  Y as orderedLocaleCodes
};
